import { Component, Input } from '@angular/core'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-boolean',
  imports: [SvgIconComponent],
  templateUrl: './boolean.component.html',
})
export class BooleanComponent {
  @Input() public value!: string
}
